import { render, staticRenderFns } from "./courseStrategy.vue?vue&type=template&id=217008a5&scoped=true&"
import script from "./courseStrategy.vue?vue&type=script&lang=js&"
export * from "./courseStrategy.vue?vue&type=script&lang=js&"
import style0 from "./courseStrategy.vue?vue&type=style&index=0&id=217008a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217008a5",
  null
  
)

export default component.exports